const formatErrorMessage = (validation, name) => {
  return typeof validation.message === 'string'
    ? validation.message.replace('[label]', name)
    : validation.message
}

export default formatErrorMessage